var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.297 2.53c3.198-1.401 6.92.072 8.313 3.29.16.373.289.882.39 1.492.101-.61.23-1.12.39-1.491 1.393-3.22 5.115-4.692 8.313-3.29 3.199 1.4 4.663 5.146 3.27 8.365-1.393 3.22-11.916 11.617-11.916 11.617l-.04-.004-.074.004S2.42 14.115 1.027 10.896c-1.393-3.219.071-6.964 3.27-8.366z",
    fill: "#60B6B1"
  })));
}
export default SvgInterest;